// De onde veio o preço que a tela aplica: a sugestão da V5 (padrão), a planilha da manhã (depois do
// reset) ou um valor editado à mão.
// Vai em cada item de /pricing/sku-calc-prices/. A V3 está desligada: sem V5 e sem edição, não há
// preço para aplicar (null) e o preço atual fica como está.
import { parseCurrencyValue } from "./pricingFormat";

// A V5 só conta como decisão quando trouxe um preço acima de zero; texto sem dígitos
// ("R$ ", espaços) vira 0 no parse e não é preço. Sem preço, a linha abre com o preço atual.
export const temDecisaoV5 = row => {
  const preco = parseCurrencyValue(row.v5?.preco_sugerido);
  return preco != null && preco > 0;
};

export const origemDoPreco = (row, editedAmeixaPrices = {}) => {
  if (editedAmeixaPrices[row.id] !== undefined) return "editado";
  const aplicado = Number(row.preco_final);
  const sugerido = Number(row.apiFinalPrice ?? row.preco_final);
  if (
    Number.isFinite(aplicado) &&
    Number.isFinite(sugerido) &&
    Math.abs(aplicado - sugerido) >= 0.001
  ) {
    return "editado";
  }
  if (row.daPlanilha) return "planilha";
  return temDecisaoV5(row) ? "v5" : null;
};
